import template from './sw-cms-preview-top-finder-selectboxes.html.twig';
import './sw-cms-preview-top-finder-selectboxes.scss';

Shopware.Component.register('sw-cms-preview-top-finder-selectboxes', {
    template
});